/* eslint-disable no-unused-vars */

import _ from 'lodash';

import z from 'app/common/z';
import { get, exists } from 'app/common/CommonUtils';

// a local storage adapter and related functions for interfacing with persistent local storage
z.store = {
  /** migrate all existing cookies into our local storage mechanism
   * migrate: () ->
   *    all = document.cookie.split('; ')
   *    cookies = {}
   *    for i in [0...all.length]
   *       cur = all[i].split('=')
   *       cookies[cur[0]] = cur[1]
   */

  /*    del = (name) ->
   *       document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
   *       document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
   */

  /*    for key, val of cookies
   *       continue if key == 'crsf' or key = 'zapsession'
   *       # val = decodeURIComponent(val.replace(/\+/g, ' ')) # undo jquery-cookie we were using
   *       log '.. migrating', key, val
   *       z.store.set key, val
   *       #del(key)
   */
  length: function() {
    return window.localStorage.length;
  },
  remove: (...args) => window.localStorage.removeItem(...args),
  clear: (...args) => window.localStorage.clear(...args),

  // handle objects by default without needing to stringify
  get: function(key) {
    let e, expire, getItem, item, val;
    try {
      getItem = (...args) => window.localStorage.getItem(...args);
      item = getItem(key);
      item = JSON.parse(item);
      expire = item[0];
      try {
        val = JSON.parse(item[1]);
      } catch (_error) {
        e = _error;
      }
      if (expire < new Date().getTime()) {
        val = null;
        z.store.remove(key);
      }
    } catch (_error) {
      e = _error;
      val = null;
    }
    return val;
  },
  set: function(key, val, options) {
    let e, expire, setItem;
    if (options == null) {
      options = {};
    }
    expire = get(options, ['expire']);
    if (!exists(expire)) {
      expire = 1000 * 60 * 60 * 24 * 365 * 100;
    }
    expire += new Date().getTime();
    if (_.isObject(val)) {
      val = JSON.stringify(val);
    }
    try {
      return window.localStorage.setItem(key, JSON.stringify([expire, val]));
    } catch (_error) {
      e = _error;
      return this.clearOldestItems(10);
    }
  },
  clearOldestItems: function(n) {
    let e,
      expiries,
      expiryDates,
      i,
      oldestDate,
      results = [];
    if (n == null) {
      n = 10;
    }
    try {
      expiries = Object.keys(window.localStorage).reduce(function(
        collection,
        key
      ) {
        let currentExpirationTime;
        currentExpirationTime = JSON.parse(window.localStorage.getItem(key))
          .expirationTime;
        collection[currentExpirationTime] = key;
        return collection;
      },
      {});

      // Get the expiry dates into an array
      expiryDates = Object.keys(expiries);

      // For N times, find the oldest (smallest timestamp) and destroy
      i = 0;
      while (i < n) {
        oldestDate = Math.min.apply(null, expiryDates);
        this.remove(expiries[oldestDate]);
        results.push(i++);
      }
    } catch (_error) {
      e = _error;
    }
    return results;
  },
};
